import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import clsx from 'clsx';
import { Button, Card, CardContent, MenuItem, Select, TextField } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import "../Styles/react-datepicker.css";
import Moment from 'moment'
import Loader from 'react-loader-spinner';
import { withStyles } from '@material-ui/core/styles';
import ChipInput from 'material-ui-chip-input';
import Tooltip from '@material-ui/core/Tooltip';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import EventIcon from '@material-ui/icons/Event';
import Confirmation from './Confirmation';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: 'lightGray',
        color: 'white',
        boxShadow: theme.shadows[1],
        fontSize: '12px',
    },
    arrow: {
        color: 'lightGray',
    }
}))(Tooltip);
const fields = [
    {
        name: 'name',
        label: 'First Name *',
        required: true,
    },
    {
        name: 'lastName',
        label: 'Last Name ',
        required: false,
    }
]

const newFields = [
    {
        name: 'emailId',
        label: 'Email ID *',
        required: true,
    },
    {
        name: 'phone',
        label: 'Phone Number *',
        required: true,
    }
]

const apps = ["Product(s) I'm interested in *", 'VisionERA', 'Assisted Closure', 'MailERA']
const maxTime = 7
@inject('commonStore') @observer
@observer
class DemoForm extends Component {
    state = {
        info: { product: ["Product(s) I'm interested in *"] },
        validationErrors: {},
        inProgress: false,
        emailIds: [],
        showConfirmation: false,
        additionalEmail: '',
        openProductMenu: false
    }

    componentDidMount() {
        if (window.local_Storage.getItem('locationInfo')) {
            if (JSON.parse(window.local_Storage.getItem('locationInfo')).hasOwnProperty('ip'))
                console.log('Location Set')
            else
                this.props.commonStore.getLocationInfo()
        }
        else {
            this.props.commonStore.getLocationInfo()
        }


    }

    validateFields = () => {
        const { validationErrors, info, emailIds } = this.state;
        let valid = true
        fields.map((row) => {
            if (row.required && !info[`${row.name}`] || (info[`${row.name}`] && !info[`${row.name}`].replace(/\s/g, '').length)) {
                validationErrors[`${row.name}`] = 'Please enter a valid ' + row.label.toLowerCase().replace("*", '')
                this.setState({ validationErrors });
                valid = false;
            }
            else if (row.name === 'name' && !this.props.commonStore.validateText(info.name)) {
                validationErrors[`${row.name}`] = 'Please enter a valid name'
                this.setState({ validationErrors });
                valid = false;
            }
            //else if (row.name === 'phone' && !this.props.commonStore.validatePhone(info.phone)) {
            else if (row.name === 'phone' && !this.props.commonStore.validateText(info.phone)) {
                validationErrors[`${row.name}`] = 'Please enter a valid phone number'
                this.setState({ validationErrors });
                valid = false;
            }
            else
                delete validationErrors[`${row.name}`]
        })
        if (!info.phone || !(info.phone.trim().length)) {
            validationErrors.phone = 'Please enter a valid phone number'
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors.phone
        if (!info.emailId || !this.props.commonStore.validateEmail(info.emailId)) {
            validationErrors.emailId = 'Please enter a valid Email ID'
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors.emailId
        if (!info.company || !this.props.commonStore.validateText(info.company)) {
            validationErrors.company = 'Please enter a valid company name'
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors.company
        if (info.product && info.product.length && info.product.includes("Product(s) I'm interested in *")) {
            validationErrors.product = 'Please select a product'
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors.product
        if (emailIds && emailIds.length) {
            emailIds.map((row) => {
                if (!this.props.commonStore.validateEmail(row)) {
                    validationErrors.emailIds = 'Please ensure all email addresses are properly formatted.'
                    this.setState({ validationErrors });
                    valid = false
                }
                else {
                    delete validationErrors.emailIds
                }

            })
        }

        else {
            delete validationErrors.emailIds
        }

        if (valid) {
            this.setState({
                validationErrors: {}
            });
        }
        return valid;
    }

    bookSlot = () => {
        let valid = false
        console.log(this.state.info)
        if (this.state.additionalEmail && this.state.additionalEmail.length) {
            let temp = this.state.emailIds.slice();

            temp.push(this.state.additionalEmail)
            this.setState({
                emailIds: temp,
                additionalEmail: ''
            }, () => {
                valid = this.validateFields()
                if (valid) {
                    this.setState({ inProgress: true })
                    let temp = new Date(this.props.match.params['date'])
                    this.props.commonStore.bookSlot(this.state.info, this.state.emailIds, Moment(temp).format('YYYY-MM-DD HH:mm'), this.props.match.params['duration'], decodeURIComponent(this.props.match.params['timezone']))
                        .then(() => {
                            window.gtag_report_conversion()
                            this.setState({ inProgress: false })
                            if (!this.props.commonStore.inProgress && !this.props.commonStore.error)
                                this.props.history.push({
                                    pathname: `/confirmation`,
                                    state: { duration: this.props.match.params['duration'], date: this.props.match.params['date'] }
                                })

                        })
                }

            });
        }
        else {
            valid = this.validateFields()
            if (valid) {
                this.setState({ inProgress: true })
                let temp = new Date(this.props.match.params['date'])
                this.props.commonStore.bookSlot(this.state.info, this.state.emailIds, Moment(temp).format('YYYY-MM-DD HH:mm'), this.props.match.params['duration'], decodeURIComponent(this.props.match.params['timezone']))
                    .then(() => {
                        window.gtag_report_conversion()
                        this.setState({ inProgress: false })
                        if (!this.props.commonStore.inProgress && !this.props.commonStore.error)
                            this.props.history.push({
                                pathname: `/confirmation`,
                                state: { duration: this.props.match.params['duration'], date: this.props.match.params['date'] }
                            })
                    })
            }
        }



    }

    handleAddEmail = (option) => {

        let temp = this.state.emailIds.slice();
        temp.push(option)
        this.setState({ emailIds: temp, additionalEmail: '' })
    }


    handleDeleteEmail = (option, index) => {
        let temp = this.state.emailIds.slice();
        temp.splice(index, 1)
        this.setState({ emailIds: temp })
    }

    constructor() {
        super()
        this.chipInputRef = React.createRef()
    }

    handleChange = (event, field, value) => {
        event.stopPropagation()
        const info = Object.assign({}, this.state.info, {
            [field]: value
        });
        this.setState({ info });
    }
    handleProductChange = (event, field, value) => {
        let newValue = JSON.parse(JSON.stringify(value))
        if (value.length) {
            if (value[0] == "Product(s) I'm interested in *")
                newValue.splice(0, 1)
        }
        else {
            newValue.push("Product(s) I'm interested in *")
        }
        event.stopPropagation()
        const info = Object.assign({}, this.state.info, {
            [field]: newValue
        });
        this.setState({ info });
    }


    onBeforeAdd = (e) => {
        this.setState({ additionalEmail: e.target.value })
    }

    onClickDone = (e) => {
        e.stopPropagation()
        this.setState({ openProductMenu: false })
    }


    render() {
        const { info, validationErrors, inProgress, emailIds, openProductMenu } = this.state;
        return (
            <div className='sc-container' id='demoForm'>
                <div className='subHeading2 bold rowFlex' style={{ justifyContent: 'space-between' }}>
                    <div className='vertCenter' style={{ flex: '1' }} id='meetingConfirmation'>Confirm your meeting</div>
                    <div className='rowFlex formButtonContainer demo-formButtonContainer' >
                        <div className={'buttonText contact-submitButton contact-cancelButton vertCenter'} onClick={(e) => this.props.history.push('/selectDate')}>
                            GO BACK
                        </div>
                        <div className={'buttonText contact-submitButton vertCenter'} onClick={this.bookSlot}>
                            {
                                inProgress ?
                                    <Loader color="white" width="10" height="10" type="ThreeDots" /> : 'CONFIRM'
                            }
                            <img height="1" width="1" style={{ display: 'none' }} alt="" src="https://px.ads.linkedin.com/collect/?pid=3394058&conversionId=4922794&fmt=gif" />
                        </div>


                    </div>
                </div>
                <div className='desc confirmDate'> {Moment(this.props.match.params['date']).format('MMMM Do YYYY, h:mm a')}</div>
                <div className={'contact-formContainer'}>

                    <div className='form-row'>
                        {fields.map((row, index) => (
                            <div key={'field' + index} className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })}>
                                <div style={{ display: 'flex', justifyContent: index === 0 ? 'flex-start' : 'flex-end', width: '100%' }}>
                                    <div className='contact-textFieldContainer' style={{ justifyContent: index === 0 ? 'flex-start' : 'flex-end' }}>
                                        <TextField variant="outlined" required={true} placeholder={row.label} className={clsx({ ['desc']: true, ['contact-textField']: true, })} classes={{ root: 'contact-textField' }} required={true}
                                            value={info[`${row}`]} onChange={(e) => this.handleChange(e, row.name, e.target.value)} style={{ width: '98%' }}
                                        />
                                        {validationErrors[row.name] ? <div className='s-desc contact-errorMsg'>{validationErrors[row.name]}</div> : null}
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                    <div className='form-row'>
                        {newFields.map((row, index) => (
                            <div key={'field' + index} className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })}>
                                <div style={{ display: 'flex', justifyContent: index === 0 ? 'flex-start' : 'flex-end', width: '100%' }}>
                                    <div className='contact-textFieldContainer' style={{ justifyContent: index === 0 ? 'flex-start' : 'flex-end' }}>
                                        <TextField variant="outlined" required={true} placeholder={row.label} className={clsx({ ['desc']: true, ['contact-textField']: true, })} classes={{ root: 'contact-textField' }} required={true}
                                            value={info[`${row}`]} onChange={(e) => this.handleChange(e, row.name, e.target.value)} style={{ width: '98%' }}
                                        />
                                        {validationErrors[row.name] ? <div className='s-desc contact-errorMsg'>{validationErrors[row.name]}</div> : null}
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>


                    <div key={'fieldEmail'} className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })} >
                        <div className='contact-textFieldContainer' style={{ width: '99%' }}>
                            <TextField variant="outlined" required={true} placeholder='Company *' className={clsx({ ['desc']: true, ['contact-textField']: true, })} classes={{ root: 'contact-textField' }} required={true}
                                value={info.company} onChange={(e) => this.handleChange(e, 'company', e.target.value)}
                            />
                            {validationErrors.company ? <div className='s-desc contact-errorMsg'>{validationErrors.company}</div> : null}
                        </div>

                    </div>
                    <div key={'fieldProduct'} className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })} style={{ marginBottom: '1vh' }}>
                        <div className='contact-multiEmail' style={{ padding: '0vh', width: '99%' }} onClick={(e) => this.setState({ openProductMenu: true })}>
                            <FormControl variant="outlined" className='fullWidth' >
                                <Select
                                    fullWidth
                                    open={openProductMenu}
                                    multiple
                                    value={info.product}
                                    classes={{ select: info.product.includes("Product(s) I'm interested in *") ? 'select-contact-textFieldContainer' : 'contact-textField' }}
                                    onChange={(e) => this.handleProductChange(e, 'product', e.target.value)}
                                    input={<Input disableUnderline={true} className={clsx({ ['desc']: true, ['contact-textField']: true, })} classes={{ root: 'contact-textField' }} />}
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    {apps.map((name) => (
                                        name === "Product(s) I'm interested in *" ?
                                            <MenuItem disableRipple={true} key={name} value={name} className={'selectPlaceholder'}>
                                                <div className='buttonText'>Please select one or more products </div>
                                                <div className='selectDone buttonText' onClick={(e) => this.onClickDone(e)}>DONE</div>
                                            </MenuItem> :
                                            <MenuItem disableRipple={true} key={name} value={name} disabled={name === "Product(s) I'm interested in *" ? true : false}>
                                                {name === "Product(s) I'm interested in *" ? null : <Checkbox checked={info.product.indexOf(name) > -1} />}
                                                <div className='buttonText'>{name === "Product(s) I'm interested in *" ? 'Please select one or more products' :
                                                    <div>{name === 'VisionERA' ? name : <span>{name}&reg;</span>}</div>
                                                } </div>
                                            </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>                            {validationErrors.product ? <div className='s-desc contact-errorMsg'>{validationErrors.product}</div> : null}




                    </div>

                    <div className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })} style={{ paddingTop: '2vh' }}>

                        <div className='contact-multiEmail'>
                            <LightTooltip title='Please type and press Enter key to enter multiple Email IDs ' arrow>
                                <ChipInput disableUnderline={true}
                                    value={emailIds}
                                    fullWidth
                                    outlined
                                    clearInputValueOnChange={true}
                                    placeholder='Guest Email ID(s)'
                                    onKeyDown={(e) => e.stopPropagation()}
                                    onChange={this.handleAddEmail}
                                    onUpdateInput={(e) => this.onBeforeAdd(e)}
                                    newChipKeyCodes={[13, 188, 9]}
                                    onBlur
                                    onAdd={(chip) => this.handleAddEmail(chip)}
                                    onDelete={(chip, index) => this.handleDeleteEmail(chip, index)}
                                />
                            </LightTooltip>
                        </div>

                        {validationErrors.emailIds ? <div className='s-desc contact-errorMsg'>{validationErrors.emailIds}</div> : null}

                    </div>

                    <div className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })} >
                        <div className='contact-textFieldContainer' style={{ paddingTop: '2vh', width: '99%' }} >
                            <TextField multiline={true} rows={2} variant="outlined" placeholder='Please share anything that will help prepare for our meeting.' required={false} className={clsx({ ['desc']: true, ['contact-textField']: true, })} classes={{ root: 'contact-textField' }}
                                value={info.note} onChange={(e) => this.handleChange(e, 'note', e.target.value)}
                            />

                        </div>

                    </div>
                    <div className='rowFlex mobile-formButtonContainer' style={{ marginLeft: '0vw' }}>
                        <div className={'buttonText contact-submitButton contact-cancelButton'} onClick={(e) => this.props.history.push('/selectDate')}>
                            GO BACK
                        </div>
                        <div className={'buttonText contact-submitButton'} onClick={this.bookSlot}>
                            {
                                inProgress ?
                                    <Loader color="white" width="10" height="10" type="ThreeDots" /> : 'CONFIRM'
                            }
                        </div>


                    </div>

                    {/* <div className='contact-textFieldContainer' style={{ width: '100%' }}>
                                                <TextField variant="outlined" className={clsx({ ['desc']: true, ['contact-textField']: true,   })} style={{ width: '100%' }} classes={{ root: 'contact-textField' }} required={true}
                                                    placeholder={'WRITE YOUR MESSAGE HERE...'} multiline={true} rowsMax={7} rows={7} value={info.message} onChange={(e) => this.handleChange(e, 'message', e.target.value)}
                                                />
                                                {validationErrors.message ? <div className='s-desc contact-errorMsg'>{validationErrors.message}</div> : null}
                                            </div>*/}


                </div>
            </div>
        )
    }
}
DemoForm.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withRouter(DemoForm);
